<template>
  <div class="page">
    <problem-list ref="problem-List" :taskList="taskList" />
  </div>
</template>

<script>
import ProblemList from "./components/problemList.vue";
export default {
  components: { ProblemList },
  data() {
    return {
      taskList: [
        { taskId: "Activity_0la3cgt", taskName: "措施审批" },
        { taskId: "Activity_05ou00x", taskName: "根因分析-审批" },
        { taskId: "Activity_1mpgwjo", taskName: "永久方案-审批" }
      ]
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
